import { render, staticRenderFns } from "./ReadCode.vue?vue&type=template&id=38218f1c&scoped=true&"
import script from "./ReadCode.vue?vue&type=script&lang=js&"
export * from "./ReadCode.vue?vue&type=script&lang=js&"
import style0 from "./ReadCode.vue?vue&type=style&index=0&id=38218f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38218f1c",
  null
  
)

export default component.exports